<script setup>
import {computed} from 'vue'
import {useUserStore} from '@/stores/user'

// Pinia Store
const userStore = useUserStore()

// Computed Property for User Preference
const lineWrapping = computed(() => {
    return userStore.pref('codeMirror_lineWrapping')
})

// Methods
const onClick = () => {
    userStore.setPref({
        name: 'codeMirror_lineWrapping',
        value: !lineWrapping.value
    })
}
</script>

<template>
    <button class="dropdown-item d-flex align-items-center" type="button" @click="onClick">
        <span
            :class="{ 'bi-square': !lineWrapping, 'bi-check-square': lineWrapping }"
            class="me-2"
        />
        Line wrapping
    </button>
</template>